<template>
  <div
    v-if="breadcrumbs?.length"
    class="sp-breadcrumbs"
    :class="[{ dark: !hero || dark }, ui?.root]"
  >
    <template
      v-for="(crumb, index) in breadcrumbs?.slice(0, breadcrumbs.length - 1) ||
      []"
      :key="index"
    >
      <NuxtLink :to="crumb.to" class="breadcrumb-link" :class="ui?.link">
        {{ crumb.name }}
      </NuxtLink>
      <span class="breadcrumb-separator" :class="ui?.separator">/</span>
    </template>
    <span class="breadcrumb-current max-md:line-clamp-1" :class="ui?.current">{{
      breadcrumbs?.[breadcrumbs.length - 1]?.name
    }}</span>
  </div>
</template>

<script lang="ts" setup>
import type { BreadcrumbItem } from '~/types'

defineOptions({
  name: 'SPBreadcrumbs',
})

withDefaults(
  defineProps<{
    breadcrumbs?: BreadcrumbItem[]
    hero?: boolean
    dark?: boolean
    ui?: {
      root?: string
      link?: string
      separator?: string
      current?: string
    }
  }>(),
  {
    hero: true,
    breadcrumbs: () => [],
    dark: false,
    ui: () => ({}),
  },
)
</script>

<style lang="scss" scoped>
.sp-breadcrumbs {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;

  &.dark {
    .breadcrumb-link {
      color: var(--color-neutral-light);
    }

    .breadcrumb-separator {
      color: var(--color-neutral-muted);
    }

    .breadcrumb-current {
      color: var(--color-neutral-default);
    }
  }
}

.breadcrumb-link,
.breadcrumb-separator,
.breadcrumb-current {
  font-size: 14px;
  line-height: 18px;
}

.breadcrumb-link {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #fff;
  }
}

.breadcrumb-separator {
  color: rgba(255, 255, 255, 0.5);
}

.breadcrumb-current {
  color: #fff;
}
</style>
